import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, ArrowRight } from "lucide-react";
import { WHATSAPP_URL } from "../lib/site";
import { useScrolledPast } from "../hooks/useScrolledPast";

// Persistent shop + WhatsApp CTA. Mobile-first: full-width bottom bar;
// on larger screens it becomes a compact floating pill, bottom-right.
export const StickyCTA = () => {
  const show = useScrolledPast(640);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-cta"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 inset-x-0 z-[65] p-3 sm:bottom-6 sm:right-6 sm:left-auto sm:inset-x-auto sm:p-0"
        >
          <div className="flex items-center gap-2.5 rounded-full bg-ivory/95 backdrop-blur-sm border border-beige p-1.5 shadow-[0_12px_40px_-12px_rgba(44,42,41,0.35)]">
            <Link
              to="/vanities"
              data-testid="sticky-shop-cta"
              className="group flex-1 sm:flex-none inline-flex items-center justify-center gap-2 rounded-full bg-charcoal text-ivory px-6 py-3.5 text-sm font-medium btn-fill hover:text-charcoal transition-colors duration-500"
            >
              Shop Vanities
              <ArrowRight size={15} strokeWidth={1.5} className="transition-transform duration-500 group-hover:translate-x-1" />
            </Link>
            <a
              href={WHATSAPP_URL()}
              target="_blank"
              rel="noreferrer"
              data-testid="sticky-whatsapp"
              aria-label="Chat on WhatsApp"
              className="grid place-items-center h-[46px] w-[46px] rounded-full border border-beige text-charcoal hover:border-charcoal transition-colors duration-300 shrink-0"
            >
              <MessageCircle size={20} strokeWidth={1.6} />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
